module.exports = __webpack_public_path__ + "static/testi-1-1-6358bd1c769e23925316687da96fc161.jpg";